import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  parseMediaDimensionValue,
  selectCreativesAuthLoaded,
  useRequestCreative,
} from '@/entities/creatives';
import { useAppSelector } from '@/shared/model';
import { useOptionalCreativeDrawerContext } from '../DataTableContext/CreativeDrawerContext';

const ImageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.25),
  height: '100%',
  aspectRatio: '1 / 1',
}));

const Image = styled('img')(() => ({
  height: '100%',
  width: '100%',
  aspectRatio: '1 / 1',
  objectFit: 'contain',
}));

interface Props {
  readonly dimension: string;
  readonly value: string;
}

export function MediaCell({ dimension, value }: Props) {
  const parsed = parseMediaDimensionValue(value);
  let displayValue = value;
  if (parsed) {
    displayValue = dimension === 'ad_name' ? parsed.ad_name : parsed.ad_id;
  }

  const creative = useRequestCreative(parsed);
  const isAuthLoaded = useAppSelector(selectCreativesAuthLoaded);
  const url = isAuthLoaded ? (creative?.thumbnailUrl ?? '') : '';
  const { openCreativeDrawer } = useOptionalCreativeDrawerContext() ?? {};

  const handleOpenDetails = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (parsed && openCreativeDrawer) {
      openCreativeDrawer(parsed);
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
        cursor: creative ? 'pointer' : 'inherit',
      }}
      onClick={handleOpenDetails}
    >
      {url && (
        <ImageWrapper>
          <Image src={url} />
        </ImageWrapper>
      )}
      <Box
        title={displayValue}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {displayValue}
      </Box>
    </Box>
  );
}
